import { TYPES } from './constants';

export const isPassword = (inputType: string) => inputType === TYPES.PASSWORD;

export const dispatchOnChangeEvent = (inputNode: HTMLInputElement, value: string) => {
    // The hack to dispatch onChange event programmatically

    // @ts-ignore
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;

    // @ts-ignore
    nativeInputValueSetter.call(inputNode, value);

    const triggerEvent = new Event('input', { bubbles: true });

    inputNode.dispatchEvent(triggerEvent);
};
